import React from 'react';
import { params, shape, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import {
  RatingsAndReviewsDefaultProps,
  RatingsAndReviewsPropTypes
} from '../RatingsAndReviewsPropTypes';import { usePresentation } from '../../context/PresentationProvider';

export const ProductAttribution = ({ itemId, originalProductName }) => {
  const { itemId: bundleId, showProductAttribution } = usePresentation();
  const hideProductLink = showProductAttribution && bundleId === itemId;

  const { data = {}, loading } = useDataModel('product', {
    variables: {
      itemId
    },
    skip: !!originalProductName
  });

  if (hideProductLink) {
    return (
      <div className="sui-mt-4 sui-mb-4 sui-text-subtle">This review is from&nbsp;
        {originalProductName}
      </div>
    );
  }

  if (!originalProductName && (loading || !data)) {
    return '';
  }
  const { product } = data;
  const { identifiers } = product || {};
  const originalProductURL = `/p/${itemId}`;
  return (
    <div className="sui-mt-4 sui-mb-4 sui-text-subtle">This review is from&nbsp;
      <a
        target="_blank"
        href={identifiers?.canonicalUrl || originalProductURL}
        rel="noreferrer"
      >{identifiers?.productLabel || originalProductName}
      </a>
    </div>
  );
};

ProductAttribution.propTypes = RatingsAndReviewsPropTypes;

ProductAttribution.defaultProps = RatingsAndReviewsDefaultProps;

ProductAttribution.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    identifiers: shape({
      itemId: stringType(),
      brandName: stringType(),
      productLabel: stringType(),
      canonicalUrl: stringType()
    })
  })
};
